import Vue from 'vue';

import './imports'

// window.App = new Vue({
//     name: 'app',
//     el: '#main',
//     //router: router,
//     data: {
//         activeIndex: '',
//     },
//     methods: {},
//     //components: components,
//     created() {},
//     mounted() {
//
//     }
// });